import { Component, Input } from '@angular/core';

@Component({
  selector: 'am-seo-search',
  styleUrls: ['./seo-search.component.scss'],
  templateUrl: './seo-search.component.html',
})
export class SeoSearchComponent {
  @Input()
  public destination: any;

  constructor() {}
}
